import { observer } from "mobx-react";
import FlexColumn from "newApp/kit/components/FlexColumn";
import TextField from "newApp/kit/components/TextField";
import { ShopCategoryFormStore } from "newApp/stores/common/ShopCategoryFormStore";
import React from "react";

export interface IRubricFormProps extends ShopCategoryFormStore {}

const CategoryForm: React.FC<IRubricFormProps> = (props) => {
  return (
    <FlexColumn>
      <TextField
        placeholder="Название рубрики"
        {...props.form.adapters.title}
      />
    </FlexColumn>
  );
};

export default observer(CategoryForm);
